import $ from 'jquery'
import lazy from '@/utils/lazy'
import {impression} from './gtmPoint'


$(function() {
  

  let $moduleList = $('div[instanceid]');
  let point = '[href*="//"],[ref*="//"],a[module-function],.J_send-log';
  let pointData = 'pageclick|keycount|';

  $(document).bind('newDomLoad', function(e, module) {
    let $module = $(module),
      instanceid = $module.attr('instanceid');

    $module.find(point).each(function() {
      let $this = $(this),
        pointTarget = point
      if (!$module.length) {
        return;
      }

      $this.attr('clstag', pointData + instanceid + '|' + ($module.find(pointTarget).index($this) + 1));
    });
    $module.attr('data-has-point', 'true');
  });


    $moduleList.each(async function(i, module) {
      let $module = $(module);

      if ($module.length === 0 || $module.attr('data-has-point') === 'true'||$module.attr('module-name') === 'TabCategory') {
        return;
      }
      await lazy(module,false)
      impression(module)
      
      $(document).trigger('newDomLoad', $module);
    });

});
